import React, { useState } from 'react';
import { CheckCircle, Circle, PartyPopper } from 'lucide-react';
import { showMessage } from '../../../scripts/showMessage.js';

const steps = [
    { key: 1, label: 'Stammdaten' },
    { key: 2, label: 'Logos' },
    { key: 3, label: 'Unterschrift' },
    { key: 4, label: 'Nummernkreise', optional: true }
];

const StepComplete = ({ stepsCompleted }) => {
    const [isFinishing, setIsFinishing] = useState(false);

    const requiredComplete = stepsCompleted[1] && stepsCompleted[2] && stepsCompleted[3];

    const handleFinish = async () => {
        if (!requiredComplete) {
            showMessage('Bitte alle Pflichtschritte abschließen', 'error');
            return;
        }

        setIsFinishing(true);

        try {
            const response = await fetch('/index.php/wizard/complete', {
                method: 'POST'
            });

            const text = await response.text();

            if (text === 'true' || text.includes('true')) {
                showMessage('Ersteinrichtung erfolgreich abgeschlossen!', 'success');
                setTimeout(() => {
                    location.reload();
                }, 2000);
            } else {
                showMessage('Fehler beim Abschließen der Ersteinrichtung', 'error');
                setIsFinishing(false);
            }
        } catch (error) {
            console.error('Error completing wizard:', error);
            showMessage('Fehler beim Abschließen der Ersteinrichtung', 'error');
            setIsFinishing(false);
        }
    };

    return (
        <div style={{ padding: '2rem 1.5rem', textAlign: 'center' }}>
            <div style={{ marginBottom: '2rem' }}>
                <h2 style={{
                    fontSize: '1.5rem',
                    fontWeight: '700',
                    color: 'var(--text-primary, #2c3e50)',
                    marginBottom: '0.75rem'
                }}>
                    Alles ausgefüllt?
                </h2>
                <p style={{
                    fontSize: '0.9375rem',
                    color: 'var(--text-secondary, #64748b)',
                    maxWidth: '500px',
                    margin: '0 auto',
                    lineHeight: '1.6'
                }}>
                    Die Punkte können jederzeit in den Einstellungen angepasst werden.
                </p>
            </div>

            {/* Checklist */}
            <div style={{
                maxWidth: '400px',
                margin: '0 auto 2rem',
                textAlign: 'left'
            }}>
                {steps.map((step) => {
                    const isComplete = stepsCompleted[step.key];
                    return (
                        <div
                            key={step.key}
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '0.75rem',
                                padding: '0.875rem 1rem',
                                borderBottom: '1px solid var(--border-light, #e2e8f0)',
                                transition: 'background 0.2s ease'
                            }}
                        >
                            {isComplete ? (
                                <CheckCircle size={22} style={{ color: 'var(--success, #28a745)', flexShrink: 0 }} />
                            ) : (
                                <Circle size={22} style={{ color: 'var(--border-medium, #cbd5e1)', flexShrink: 0 }} />
                            )}
                            <span style={{
                                fontSize: '0.9375rem',
                                fontWeight: '500',
                                color: isComplete
                                    ? 'var(--text-primary, #2c3e50)'
                                    : 'var(--text-secondary, #64748b)'
                            }}>
                                {step.label}
                                {step.optional && (
                                    <span style={{
                                        fontSize: '0.75rem',
                                        color: 'var(--text-muted, #94a3b8)',
                                        marginLeft: '0.5rem'
                                    }}>
                                        (optional)
                                    </span>
                                )}
                            </span>
                        </div>
                    );
                })}
            </div>

            {/* Finish button */}
            <button
                onClick={handleFinish}
                disabled={!requiredComplete || isFinishing}
                style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '0.5rem',
                    padding: '0.75rem 2rem',
                    border: 'none',
                    borderRadius: '8px',
                    background: requiredComplete ? 'var(--accent-slate, #5b7c8d)' : 'var(--border-medium, #cbd5e1)',
                    color: 'white',
                    fontSize: '1rem',
                    fontWeight: '600',
                    cursor: requiredComplete && !isFinishing ? 'pointer' : 'not-allowed',
                    opacity: isFinishing ? 0.7 : 1,
                    transition: 'all 0.2s ease'
                }}
            >
                {isFinishing ? 'Wird abgeschlossen...' : 'Ersteinrichtung abschließen'}
            </button>

            {!requiredComplete && (
                <p style={{
                    fontSize: '0.8125rem',
                    color: 'var(--text-muted, #94a3b8)',
                    marginTop: '0.75rem'
                }}>
                    Bitte alle Pflichtschritte (1-3) abschließen
                </p>
            )}
        </div>
    );
};

export default StepComplete;
